var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pack-mockups",
      style: `background-color: var(--fa-${_vm.iconPack().theme.primary});`,
    },
    _vm._l(_vm.mockups, function (mockup, index) {
      return _c(
        "div",
        {
          key: `${mockup.image}-${index}`,
          class: `pack-mockup pack-mockup-${index}`,
        },
        [
          _c("img", {
            staticClass: "pack-mockup-image",
            attrs: {
              src: `/images/icons/packs/${_vm.iconPack().name}/${mockup.image}`,
              alt: mockup.altText ? mockup.altText : "",
              "aria-hidden": "",
            },
          }),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }